import { trapFocus } from '../_utils/focus.js';
export default (togglerSelector = '.navbar-toggler') => {
  const togglers = Array.from(document.querySelectorAll(togglerSelector));
  let releaseTrap = null;
  const setupToggler = element => {
    const closeText = element.getAttribute('data-label-close');
    const openText = element.getAttribute('aria-label');
    if (!closeText || !openText) {
      return;
    }
    let collapsed = false;
    const updateCollapsed = () => {
      collapsed = element.classList.contains('collapsed');
    };
    updateCollapsed();
    let animationFrame = null;
    element.addEventListener('click', () => {
      // Wait a frame to ensure the expanded attribute has been updated.
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
      // TODO: Should update all elements with the same target as well!
      animationFrame = requestAnimationFrame(() => {
        updateCollapsed();
        const text = collapsed && collapsed !== 'false' ? closeText : openText;
        element.setAttribute('aria-label', text);
        if (releaseTrap) {
          releaseTrap();
        }
        if (!collapsed) {
          releaseTrap = trapFocus(element.closest('header.nav-header'));
        }
      });
    });
  };
  for (const toggler of togglers) {
    setupToggler(toggler);
  }
};